import React from 'react';

// Newest first (as the API returns). Payer/system entries are labelled so a
// reader can tell who did what.
const WHO = { payer: 'Payer / clearinghouse', system: 'System' };

export default function ClaimTimeline({ events }) {
  if (!events || events.length === 0) return <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>No activity yet.</div>;
  return (
    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {events.map((e) => (
        <li key={e.id} style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 160px) 1fr', gap: 10, padding: '8px 0', borderBottom: '1px solid var(--border-color)', fontSize: 13 }}>
          <div style={{ color: 'var(--text-muted)' }}>{new Date(e.created_at).toLocaleString()}</div>
          <div>
            <div style={{ overflowWrap: 'anywhere' }}>{e.message}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
              {e.actor_name || WHO[e.actor_kind] || 'User'}{e.from_status && e.to_status ? ` · ${e.from_status} → ${e.to_status}` : ''}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
